import React from 'react';
import { Link } from 'react-router-dom';

function Footer() {
  const footerLinks = [
    { id: 1, text: 'Home', path: '/' },
    { id: 2, text: 'Products', path: '/products' },
    { id: 3, text: 'Promotions', path: '/promotions' },
    { id: 4, text: 'About us', path: '/about-us' },
    { id: 5, text: 'Brands', path: '/brands' },
  ];

  return (
    <footer className="bg-gray-200 py-6 mt-2">
      <div className="container mx-auto">
        <div className="flex flex-col lg:flex-row justify-between items-center">
          <div className="mb-4 lg:mb-0">
            <p className="text-lg font-bold">A Marketplace for Your Goods</p>
          </div>
          <div>
            <ul className="flex flex-wrap gap-4 text-sm">
              {footerLinks.map((link) => (
                <li key={link.id}>
                  <Link to={link.path} className="hover:text-blue-600 hover:underline">{link.text}</Link>
                </li>
              ))}
            </ul>
          </div>
        </div>
        <hr className="my-6 border-t border-gray-300" />
        <p className="text-sm text-center">Privacy | Policy <span className="text-gray-500">Antony web design @2023</span></p>
      </div>
    </footer>
  );
}

export default Footer;
